import { Dispatch, SetStateAction } from 'react';
import { setCurrentCoords } from '../../../../app/redux/slices/currentCoordinatesSlice';
import { AnyAction } from '@reduxjs/toolkit';
import { sendDataToParent } from './sendDataToParent';
import { setIsMapZoomingState } from '../../../../app/redux/slices/isMapZoomingSlice';
import { setCurrentZoomLevel } from '../../../../app/redux/slices/currentZoomLevelSlice';
import { GetLocationDataApi } from '../../../../core/data/api/GetLocationDataApi';

export const getMapEventsObject = (
    dispatch: Dispatch<AnyAction>,
    mapIframeId: string,
    isDrawPolylineActive: boolean,
    isDrawPolygonActive: boolean,
    isGetCurrentCenterAndZoom: boolean,
    isGetCurrentBoundingBox: boolean,
    isUsingMeasuringTool: boolean,
    isSendAnimationEnd: boolean,
    isOnMapClick: boolean,
    setIsLoading: Dispatch<SetStateAction<boolean>>,
) => {
    return {
        click(e: any) {
            const isButtonClicked = e.originalEvent.target.tagName === 'BUTTON';
            if (!isDrawPolygonActive && !isDrawPolylineActive && !isUsingMeasuringTool && !isButtonClicked) {
                sendDataToParent({
                    type: 'map-clicked',
                    currentCoords: { lat: e.latlng.lat, lng: e.latlng.lng },
                });
            }

            if (isOnMapClick) {
                setIsLoading(true);
                GetLocationDataApi(e.latlng.lat, e.latlng.lng).then((data) => {
                    setIsLoading(false);

                    sendDataToParent({
                        type: 'map-clicked',
                        locationData: data,
                    });
                });
            }
        },
        mousemove(e: any) {
            // console.log('MOUSE MOVE: ', e);
            dispatch(setCurrentCoords({ lat: e.latlng.lat, lng: e.latlng.lng }));
        },
        zoom(e: any) {
            if (e.flyTo) {
                dispatch(setIsMapZoomingState(true));
            } else {
                dispatch(setIsMapZoomingState(false));
                isSendAnimationEnd && sendDataToParent({ type: 'animation-stopped', isStopped: true });
            }
        },
        zoomend(e: any) {
            // console.log('current zoom:', e.target.getZoom());
            dispatch(setIsMapZoomingState(false));
            dispatch(setCurrentZoomLevel(e.target.getZoom()));

            const mapBoundingBox = e.target.getBounds();

            isGetCurrentBoundingBox &&
                sendDataToParent({
                    type: 'map-bounding-box',
                    mapBoundingBox,
                });

            if (isGetCurrentCenterAndZoom) {
                const zoom = e.target.getZoom();
                const center = e.target.getCenter();
                // const boundingBox = e.target.getBounds();
                // console.log('bounding box check: ', boundingBox);
                sendDataToParent({
                    type: 'current-center-zoom',
                    currentMapId: mapIframeId,
                    currentZoom: zoom,
                    currentCenter: center,
                });
            }
        },
        moveend(e: any) {
            // console.log('move end:', e.target.getCenter());
            dispatch(setCurrentZoomLevel(e.target.getZoom()));

            const mapBoundingBox = e.target.getBounds();

            // console.log('bounding box check: ', mapBoundingBox);

            isSendAnimationEnd && sendDataToParent({ type: 'animation-stopped', isStopped: true });

            isGetCurrentBoundingBox &&
                sendDataToParent({
                    type: 'map-bounding-box',
                    mapBoundingBox,
                });

            if (isGetCurrentCenterAndZoom) {
                const zoom = e.target.getZoom();
                const center = e.target.getCenter();
                sendDataToParent({
                    type: 'current-center-zoom',
                    currentMapId: mapIframeId,
                    currentZoom: zoom,
                    currentCenter: center,
                });
                isSendAnimationEnd && sendDataToParent({ type: 'animation-stopped', isStopped: true });
            }
        },
    };
};
